/**
 * If `condition` is truthy, call `fn` with arguments passed after `condition`.
 * Does not accept Promises. We'll need a different function to handle async
 * functions.
 */
export function maybeDo<Fn extends (...args: any[]) => any>(
  condition?: boolean,
  fn?: ReturnType<Fn> extends Promise<any> ? never : Fn,
  ...args: Parameters<Fn>
): MaybeDoReturnType<Fn> {
  if (fn && condition) {
    return fn(...args);
  }

  // I can't figure out a way to do this without casting. At runtime, JS can't
  // type check a function's return value without invoking it, so we can't get
  // any inference or assertion help here that's useful (the assertion function
  // wouldn't be able to test anything meaningfully).

  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return undefined as MaybeDoReturnType<Fn>;
}

type MaybeDoReturnType<Fn extends (...args: any[]) => any> =
  ReturnType<Fn> extends Promise<any> ? never : ReturnType<Fn> | undefined;
